import { Coach, ConsultCoachCard } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const STRINGS = appStrings.modules.coaches;

type CoachesContentProps = Readonly<{
  coaches: Coach[];
  onCardClick?: (coach: Coach) => void;
  onCtaClick?: (coach: Coach) => void;
}>;

export const CoachesContent = ({ coaches, onCardClick, onCtaClick }: CoachesContentProps) => {
  if (coaches.length === 0) {
    return (
      <Box sx={emptyStateSx}>
        <Typography variant="text-lg-semibold" sx={emptyTitleSx}>
          {STRINGS.emptyState.title}
        </Typography>
        <Typography variant="text-md-regular" sx={emptySubtitleSx}>
          {STRINGS.emptyState.subtitle}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={gridSx}>
      {coaches.map((coach) => (
        <Box key={coach.id}>
          <ConsultCoachCard coach={coach} onCardClick={onCardClick} onCtaClick={onCtaClick} />
        </Box>
      ))}
    </Box>
  );
};

const gridSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, 286px)',
  gap: backrs.spacing['spacing-lg'],
});

const emptyStateSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: backrs.spacing['spacing-4xl'],
  gap: backrs.spacing['spacing-md'],
});

const emptyTitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const emptySubtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
